import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@emotion/css';
import { useLocalization } from '../../Localization';
import { Spinner } from '@vp/swan';
const spinnerStyle = css `
    width: 33%;
    margin: auto;
    display: flex;
    justify-content: center;
`;
/**
 * Default spinner to show when the drawer is loading
 */
export const DrawerListSpinner = () => {
    const { loadingLabel } = useLocalization();
    return (_jsx("div", Object.assign({ className: spinnerStyle, "data-testid": "loading-spinner" }, { children: _jsx(Spinner, { size: "super", accessibleText: loadingLabel, role: "status" }) })));
};
DrawerListSpinner.displayName = 'DrawerListSpinner';
//# sourceMappingURL=DrawerListSpinner.js.map